import React, { createContext, useMemo, useReducer } from 'react';

import { buildActionMap } from './actionMap';
import { createInitialState, SearchFormReducer } from './reducer';
import { SearchFormActions, SearchFormData } from './types';

const createDefaultSearchFormData = (): SearchFormData => ({
    activeFilterList: [],
});

export const SearchFormContext = createContext(createDefaultSearchFormData());

const createDefaultSearchFormActionMap = (): SearchFormActions => ({
    updateActiveFilterList() {},
    removeActiveFilter() {},
    removeAllActiveFilter() {},
});

export const SearchFormActionContext = createContext(
    createDefaultSearchFormActionMap()
);

export const SearchFormProvider: React.FC<React.PropsWithChildren> = ({
    children,
}) => {
    const [reducerState, dispatch] = useReducer(
        SearchFormReducer,
        createInitialState()
    );

    const actionMap = useMemo(() => buildActionMap(dispatch), []);

    const contextState = useMemo<SearchFormData>(
        () => ({
            activeFilterList: reducerState.activeFilterList,
        }),
        [reducerState.activeFilterList]
    );

    return (
        <SearchFormActionContext.Provider value={actionMap}>
            <SearchFormContext.Provider value={contextState}>
                {children}
            </SearchFormContext.Provider>
        </SearchFormActionContext.Provider>
    );
};
